/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import { graphql, useStaticQuery } from 'gatsby'
import EventItem from './products/event-item'
import ProductItem from './products/product-item'
import ProductItemCard from './products/product-item-card'
import { windowObject } from "../../../../utils/browser-helpers";
import { isMobile } from "react-device-detect";

const Products = ({ project, onPrezzoClick }) => {

  const dataImages = useStaticQuery(graphql`
  {
    allFile {
      edges {
        node {
          publicURL
          base
        }
      }
    }
  }
  `);

  const dispatchProductItem = (p, dataImages) => {
    if (p.product_type == 'card') {
      return <ProductItemCard project={project} product={p} dataImages={dataImages} onPrezzoClick={() => {

        // Da desktop si apre la registrazione
        var url = process.env.REGISTRATION_URL;

        // Da mobile si apre l'app se installata, oppure lo store
        if (isMobile) {
          url = `https://deeplink.tinaba.it/`;
        }
        const wObj = windowObject();
        if (wObj) {
          wObj.open(url);
        }

      }} />
    }
    else {
      return <ProductItem product={p} dataImages={dataImages} onPrezzoClick={onPrezzoClick} />;
    }
  }

  return (
    <>
      <div className="flex flex-col">
        <div className="flex-col container-grid desktop:flex">

          <div className="text-2 leading-11 mobile:col-span-4 desktop:text-24 desktop:leading-21  font-md text-black text-center" style={{ marginTop: '50px' }}>Lo store più esclusivo di sempre</div>
          <div className="text-6 leading-7 mobile:col-span-4 desktop:text-5 desktop:leading-8 font-rgtext-black text-center" style={{ lineHeight: '24px', marginTop: '16px' }}>Registrati a Tinaba con il codice <b>{project.promocode}</b> e attiva la mia membership.<br />Con Tinaba Hit, carta, conto, prodotti riservati e scontati e meet and greet!</div>
        </div>
        {project.highlights.map(p => dispatchProductItem(p, dataImages))}
        {project.events.map(e => <EventItem event={e} dataImages={dataImages} onPrezzoClick={onPrezzoClick} />)}
        {project.products.map(p => <ProductItem product={p} dataImages={dataImages} onPrezzoClick={onPrezzoClick} />)}
      </div>
    </>
  );
}

export default Products
